import React from "react";
import { Navigate } from "react-router-dom";
import useCurrentUserAccess from "../hooks/useCurrentUserAccess";

function SupportAdminRoute({ children }) {
  const { loading, platformRole, platformPermissions } = useCurrentUserAccess();

  const isPlatformAdmin = platformRole?.key_name === "platform_admin";
  const isPlatformSupport = platformRole?.key_name === "platform_support";

  const hasSupportPermission = Array.isArray(platformPermissions)
    ? platformPermissions.some((permission) => {
        if (typeof permission === "string") {
          return permission === "manage_support_tickets";
        }

        return permission?.key_name === "manage_support_tickets";
      })
    : false;

  if (loading) {
    return (
      <div className="main-content">
        <div style={{ padding: "2rem" }}>Loading support access...</div>
      </div>
    );
  }

  if (!isPlatformAdmin && !isPlatformSupport && !hasSupportPermission) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default SupportAdminRoute;